export default {
    BODY: 'body',
    FOOTER: 'footer',
    HEADER: 'header',
};
